<template>
  <div class="section-right-content-box" style="min-width: 1046px">
    <div class="box-shadow top-box">
      <div class="global-title cover">客户价值分析</div>
      <el-tabs class="choose" v-model="activeName" type="card" @tab-click="handleClick">
        <el-tab-pane label="消费频次分析" name="first"></el-tab-pane>
        <el-tab-pane label="消费能力分析" name="second"></el-tab-pane>
      </el-tabs>
      <el-radio v-model="DateRadio" label="1" @change="dateChange">近30天</el-radio>
      <el-radio v-model="DateRadio" label="2" @change="dateChange">近90天</el-radio>
      <el-radio v-model="DateRadio" label="3" @change="dateChange">近180天</el-radio>
      <el-radio v-model="DateRadio" label="4" @change="dateChange">近1年</el-radio>
      <el-radio v-model="DateRadio" label="5" @change="dateChange">历史所有</el-radio>

      <el-button class="exportData" @click="exportData">导出数据</el-button>
      <el-button class="exportData" style="margin-right:15px" @click="handleCusto()">自定义参数</el-button>
      <div>
        <!-- 图表数据 -->
        <div class="charts" v-loading="loading">
          <div class="background">
            <span class="title"></span>&nbsp;
            <span class="tips">数据图表</span>
          </div>
          <div id="order-care" :style="{ width: '100%', height: '400px' }"></div>
          <!-- 列表表格 -->
          <div class="background">
            <span class="title"></span>&nbsp;
            <span class="tips">数据报表</span>
          </div>
          <div style="margin-top: 20px">
            <el-table :data="frequencyData" border :header-cell-style="{ background: '#fafafa', fontWeight: 700 }" style="width: 100%">
              <el-table-column :prop="isAbility ? 'shopAmountStr' : 'shopTimesStr'" :label="isAbility ? '购买金额' : '购买次数'" width="300">
              </el-table-column>
              <el-table-column prop="customerNum" label="客户数量" width="300"> </el-table-column>
              <el-table-column label="占比">
                <template slot-scope="scope">
                  <el-progress :percentage="scope.row.percent.substring(0, scope.row.percent.length - 1) * 1"></el-progress>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="120px">
                <template slot-scope="scope">
                  <span class="titiecolor" @click="createCrow(activeName == 'first' ? scope.row.shopTimes : scope.row.shopAmountRange)">生成人群</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>

      <el-dialog title="设置参数" :visible.sync="RFMvisible" width="600px" @close="RFMvisible = false" class="addMemberDialog">
        <div class="RFMBox" v-if="activeName == 'first'">
          <div>F：购买次数</div>
          <div class="RFMBox-top">
            <el-input style="width:70px" :value="Fitem.zaroinfo" @input="(e) => (Fitem.zaroinfo = validSe(e))" @change="handleRFM()"></el-input>&nbsp;
            - &nbsp;
            <el-input style="width:70px" :value="Fitem.oneinfo" @input="(e) => (Fitem.oneinfo = validSe(e))" @change="handleRFM()"></el-input>&nbsp; -
            &nbsp;
            <el-input style="width:70px" :value="Fitem.twoinfo" @input="(e) => (Fitem.twoinfo = validSe(e))" @change="handleRFM()"></el-input>&nbsp; -
            &nbsp;
            <el-input style="width:70px" :value="Fitem.threeinfo" @input="(e) => (Fitem.threeinfo = validSe(e))" @change="handleRFM()"></el-input
            >&nbsp; - &nbsp;
            <el-input style="width:70px" :value="Fitem.fourinfo" @input="(e) => (Fitem.fourinfo = validSe(e))" @change="handleRFM()"></el-input>
          </div>
          <div class="RFMBox-top">
            F={{ Fitem.zaroinfo }}，F={{ Fitem.oneinfo }}，F={{ Fitem.twoinfo }}，F={{ Fitem.threeinfo }}，F≥{{ Fitem.fourinfo }}
          </div>
        </div>

        <div class="RFMBox" v-else>
          <div>M：购买金额</div>
          <div class="RFMBox-top">
            <span style="color:#000">0</span>&nbsp; - &nbsp;
            <el-input style="width:70px" :value="Mitem.oneinfo" @input="(e) => (Mitem.oneinfo = validSe(e, 1))" @change="handleRFM()"></el-input
            >&nbsp; - &nbsp;
            <el-input style="width:70px" :value="Mitem.twoinfo" @input="(e) => (Mitem.twoinfo = validSe(e))" @change="handleRFM()"></el-input>&nbsp; -
            &nbsp;
            <el-input style="width:70px" :value="Mitem.threeinfo" @input="(e) => (Mitem.threeinfo = validSe(e))" @change="handleRFM()"></el-input
            >&nbsp; - &nbsp;
            <el-input style="width:70px" :value="Mitem.fourinfo" @input="(e) => (Mitem.fourinfo = validSe(e))" @change="handleRFM()"></el-input>
          </div>
          <div class="RFMBox-top">
            M≤{{ Mitem.oneinfo == "0" ? "" : Mitem.oneinfo }}，{{ Mitem.oneinfo == "0" ? "" : Mitem.oneinfo }}＜M≤{{ Mitem.twoinfo }}，{{
              Mitem.twoinfo
            }}＜M≤{{ Mitem.threeinfo }}，{{ Mitem.threeinfo }}＜M≤{{ Mitem.fourinfo }}，M＞{{ Mitem.fourinfo }}
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button class="cancel_Btn" @click="RFMvisible = false">取 消</el-button>
          <el-button type="primary" @click="handleSave()" class="sure_Btn">确 定</el-button>
        </span>
      </el-dialog>
    </div>
      <!-- 生成报表 -->
      <generate :control = 'control' 
                 v-if="control"
                  @transData="(val) => (control = val)"
                  @transData1 = 'getphone1'
      ></generate>
    <!-- 生成人群 -->
    <crowdCreate 
      :isShow.sync="isShowCrowdDialog" 
      :crowdTag="crowdTag"
      :label="label"
    />
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import { buyerGradeCount } from "@/api/analysis/monthly-report";
import { consumptionFrequency, consumptionCapacity, exportData, analysiSave, analysiconfigs,exportDataOne } from "@/api/analysis/people_worth";
import generate from '../../components/generate_report.vue'
import crowdCreate from "@/components/crowd-create.vue";

export default {
  name: "monthly_report",
  data() {
    return {
      label: "",
      crowdTag: "",
      isShowCrowdDialog: false,
      control:false,
      Mitem: {
        oneinfo: "100",
        twoinfo: "300",
        threeinfo: "500",
        fourinfo: "800",
      },
      Fitem: {
        zaroinfo: "1",
        oneinfo: "2",
        twoinfo: "3",
        threeinfo: "4",
        fourinfo: "5",
      },
      RFMvisible: false,
      frequencyX: [], // 消费频次X轴
      frequencyY: [], // 消费频次Y轴
      frequencyData: [], //消费频次数据
      label1: "opdata_shop_last30days_ord_num", // 频次传参
      label2: "opdata_shop_last30days_ord_amount", // 能力传参
      DateRadio: "1",
      isAbility: false,
      activeName: "first",
      loading: true,
      postForm: {
        startDate: "",
        endDate: "",
      },
      mytime: [],
      zxData: {
        timeFlag: [],
        buyerCount: [],
        tradeCount: [],
        payment: [],
        buyerAvgCost: [],
      },
      recordData: [],
      people: 0,
      updataTime: "",
    };
  },
  computed: {
    ...mapState({
      changeColor: "globalBG",
    }),
  },
  components: {
    generate,
    crowdCreate,
  },
  created() {
    this.consumptionFrequency();

    // 埋点
    this.buriedPoint(1, '客户价值分析', '数据分析', '客户分析')
  },

  methods: {
    // 生成人群
    createCrow(name) {
      this.crowdTag = name ? name : "合计" // 消费频次字段为null，需特殊处理
      this.filterLabel()
      this.isShowCrowdDialog = true
    },

    // 过滤lable
    filterLabel() {
      if (this.activeName == "first") {
        switch (this.DateRadio) {
          case "1": 
            this.label = "opdata_shop_last30days_ord_num"
            break
          case "2": 
            this.label = "opdata_shop_last90days_ord_num"
            break
          case "3": 
            this.label = "opdata_shop_last180days_ord_num"
            break
          case "4": 
            this.label = "opdata_shop_lastoneyear_ord_num"
            break
          case "5": 
            this.label = "opdata_shop_complete_ord_num"
            break
        }
      } else {
        switch (this.DateRadio) {
          case "1": 
            this.label = "opdata_shop_last30days_ord_amount"
            break
          case "2": 
            this.label = "opdata_shop_last90days_ord_amount"
            break
          case "3": 
            this.label = "opdata_shop_last180days_ord_amount"
            break
          case "4": 
            this.label = "opdata_shop_lastoneyear_ord_amount"
            break
          case "5": 
            this.label = "opdata_shop_complete_ord_amount"
            break
        }
      }
    },

    async handleCusto() {
      const { data: res } = await analysiconfigs();
      if (res.consumptionFrequencyCondition) {
        let arr = res.consumptionFrequencyCondition.split(",");
        this.Fitem = {
          zaroinfo: arr[0],
          oneinfo: arr[1],
          twoinfo: arr[2],
          threeinfo: arr[3],
          fourinfo: arr[4],
        };
      } else {
        this.Fitem = {
          zaroinfo: "1",
          oneinfo: "2",
          twoinfo: "3",
          threeinfo: "4",
          fourinfo: "5",
        };
      }
      if (res.consumptionCapacityCondition) {
        let arr = res.consumptionCapacityCondition.split(",");
        this.Mitem = {
          oneinfo: arr[0],
          twoinfo: arr[1],
          threeinfo: arr[2],
          fourinfo: arr[3],
        };
      } else {
        this.Mitem = {
          oneinfo: "100",
          twoinfo: "300",
          threeinfo: "500",
          fourinfo: "800",
        };
      }
      this.RFMvisible = true;
    },
    async handleSave() {
      if (this.activeName === "first") {
        let str = this.Fitem.zaroinfo + "," + this.Fitem.oneinfo + "," + this.Fitem.twoinfo + "," + this.Fitem.threeinfo + "," + this.Fitem.fourinfo;
        if (!this.Fitem.zaroinfo || !this.Fitem.oneinfo || !this.Fitem.twoinfo || !this.Fitem.threeinfo || !this.Fitem.fourinfo)
          return this.$message.warning("请填写完整");
        const res = await analysiSave({ consumptionFrequencyCondition: str });
        if (res.code != 1) return this.$message.error(res.message);
        this.frequencyX = [];
        this.frequencyY = [];
        this.frequencyData = [];
        this.RFMvisible = false;
        this.consumptionFrequency(this.label1);
      } else {
        let str = this.Mitem.oneinfo + "," + this.Mitem.twoinfo + "," + this.Mitem.threeinfo + "," + this.Mitem.fourinfo;
        if (!this.Mitem.oneinfo || !this.Mitem.twoinfo || !this.Mitem.threeinfo || !this.Mitem.fourinfo) return this.$message.warning("请填写完整");
        const res = await analysiSave({ consumptionCapacityCondition: str });
        if (res.code != 1) return this.$message.error(res.message);
        this.frequencyX = [];
        this.frequencyY = [];
        this.frequencyData = [];
        this.RFMvisible = false;
        this.consumptionCapacity(this.label2);
      }
    },
    //输入大于0的正整数
    validSe(data) {
      let filtered = data.replace(/[^\d]/g, "");
      if (Number(filtered) < 1) {
        filtered = "";
      }
      return filtered;
    },
    // 判断逐渐递增，不能相等
    handleRFM() {
      const num = Number(this.Fitem.zaroinfo);
      const num1 = Number(this.Fitem.oneinfo);
      const num2 = Number(this.Fitem.twoinfo);
      const num3 = Number(this.Fitem.threeinfo);
      const num4 = Number(this.Fitem.fourinfo);
      // Fitem
      if (num >= num1 && this.Fitem.oneinfo && this.Fitem.zaroinfo) {
        this.Fitem.oneinfo = "";
        this.$message.warning("需要逐渐递增，不能相等");
      }
      if (num1 >= num2 && this.Fitem.oneinfo && this.Fitem.twoinfo) {
        this.Fitem.twoinfo = "";
        this.$message.warning("需要逐渐递增，不能相等");
      }
      if (num2 >= num3 && this.Fitem.twoinfo && this.Fitem.threeinfo) {
        this.Fitem.threeinfo = "";
        this.$message.warning("需要逐渐递增，不能相等");
      }
      if (num3 >= num4 && this.Fitem.threeinfo && this.Fitem.fourinfo) {
        this.Fitem.fourinfo = "";
        this.$message.warning("需要逐渐递增，不能相等");
      }

      const mnum1 = Number(this.Mitem.oneinfo);
      const mnum2 = Number(this.Mitem.twoinfo);
      const mnum3 = Number(this.Mitem.threeinfo);
      const mnum4 = Number(this.Mitem.fourinfo);
      // Mitem
      if (mnum1 >= mnum2 && this.Mitem.oneinfo && this.Mitem.twoinfo) {
        this.Mitem.twoinfo = "";
        this.$message.warning("需要逐渐递增，不能相等");
      }
      if (mnum2 >= mnum3 && this.Mitem.twoinfo && this.Mitem.threeinfo) {
        this.Mitem.threeinfo = "";
        this.$message.warning("需要逐渐递增，不能相等");
      }
      if (mnum3 >= mnum4 && this.Mitem.threeinfo && this.Mitem.fourinfo) {
        this.Mitem.fourinfo = "";
        this.$message.warning("需要逐渐递增，不能相等");
      }
    },
    // 消费能力
    async consumptionCapacity(label = "opdata_shop_last30days_ord_amount") {
      this.loading = true;
      const { data } = await consumptionCapacity({ label });
      this.frequencyData = data;
      data.forEach((item) => {
        this.frequencyX.push(item.customerNum);
        this.frequencyY.push(item.shopAmountStr);
      });
      this.frequencyY = this.frequencyY.slice(0, this.frequencyY.length - 1);
      this.draw();
      this.loading = false;
    },

    // 消费频次
    async consumptionFrequency(label = "opdata_shop_last30days_ord_num") {
      this.loading = true;
      const { data } = await consumptionFrequency({ label });
      this.frequencyData = data;
      data.forEach((item) => {
        this.frequencyX.push(item.customerNum);
        this.frequencyY.push(item.shopTimesStr);
      });
      this.frequencyY = this.frequencyY.slice(0, this.frequencyY.length - 1);
      this.draw();
      this.loading = false;
    },

    draw() {
      this.$nextTick(() => {
        this.drawOrderCareBar();
        window.addEventListener("resize", () => {
          this.myCharts.resize();
        });
      });
    },

    dateChange(val) {
      this.frequencyX = [];
      this.frequencyY = [];
      this.frequencyData = [];
      if (val == 1) {
        this.label1 = "opdata_shop_last30days_ord_num";
        this.label2 = "opdata_shop_last30days_ord_amount";
      } else if (val == 2) {
        this.label1 = "opdata_shop_last90days_ord_num";
        this.label2 = "opdata_shop_last90days_ord_amount";
      } else if (val == 3) {
        this.label1 = "opdata_shop_last180days_ord_num";
        this.label2 = "opdata_shop_last180days_ord_amount";
      } else if (val == 4) {
        this.label1 = "opdata_shop_lastoneyear_ord_num";
        this.label2 = "opdata_shop_lastoneyear_ord_amount";
      } else {
        this.label1 = "opdata_shop_complete_ord_num";
        this.label2 = "opdata_shop_complete_ord_amount";
      }
      if (this.isAbility) {
        this.consumptionCapacity(this.label2);
      } else {
        this.consumptionFrequency(this.label1);
      }
    },
    async exportData() {
      this.control = true;
    },
    getphone1(val){    
      let params = {
        frequencyLabel: this.label1,
        capacityLabel: this.label2,
        exportRemark:val
      };
      let paramStr = "";
      for (var key in params) {
        let temp = "&" + key + "=" + params[key];
        paramStr += temp;
      }
      paramStr = paramStr.substr(1);
      exportDataOne(paramStr).then((res)=>{
        if(res.code==1){
             this.control = true;
        }else{
          this.$message.error(res.message);
        }
      })
    },
    handleClick(val) {
      this.frequencyX = [];
      this.frequencyY = [];
      this.frequencyData = [];
      if (val.name === "first") {
        this.isAbility = false;
        this.consumptionFrequency(this.label1);
      } else {
        this.isAbility = true;
        this.consumptionCapacity(this.label2);
      }
    },

    //绘制柱状图
    drawOrderCareBar() {
      let self = this;
      let orderCareBarChartOne = this.$echarts.init(document.getElementById("order-care"), "light"); //初始化echats实例
      orderCareBarChartOne.setOption({
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        legend: {},
        grid: {
          left: "3%",
          right: "4%",
          top: "10%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: {
          type: "value",
          boundaryGap: [0, 0.01],
          data: this.frequencyX,
          axisLine: {
            //y轴
            show: false,
          },
          axisTick: {
            //y轴刻度线
            show: false,
          },
          splitLine: {
            //网格线
            show: true,
            color: "#999",
          },
        },
        yAxis: {
          type: "category",
          data: this.frequencyY,
        },
        series: [
          {
            type: "bar",
            barWidth: 20, //柱图宽度
            data: this.frequencyX,
            itemStyle: {
              normal: {
                label: {
                  show: true, //开启显示
                  position: "right", //在上方显示
                  textStyle: {
                    //数值样式
                    color: "#666",
                    fontSize: 14,
                  },
                },
                color: function(params) {
                  var colorList = ["#7f86ea", "#7f86ea", "#7f86ea", "#7f86ea", "#7f86ea", "#7f86ea"];
                  return colorList[params.dataIndex];
                },
              },
            },
          },
        ],
      });
      window.onresize = function() {
        orderCareBarChartOne.resize();
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.titiecolor {
  cursor: pointer;
  color: #7f85e9;

  &:hover {
    color: #fe4d45;
  }
}
.RFMBox {
  padding: 10px 0px 25px 17px;
  color: #000;
  .RFMBox-top {
    color: #999;
    margin-left: 24px;
    margin-top: 15px;
  }
}
.section-right-content-box {
  margin-top: 10px;
  -webkit-border-radius: 6px;
  -moz-border-radius: 6px;
  border-radius: 6px;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  opacity: 1;
  margin: 10px 20px 20px 20px;
  padding: 0 28px;

  /deep/.el-progress-bar {
    padding-right: 70px;
    display: inline-block;
    vertical-align: middle;
    width: 100%;
    margin-right: -76px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }

  /deep/.el-progress-bar__inner {
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    background-color: #7e86ec;
    text-align: right;
    border-radius: 100px;
    line-height: 1;
    white-space: nowrap;
    -webkit-transition: width 0.6s ease;
    transition: width 0.6s ease;
  }

  .exportData {
    float: right;
  }

  .cover {
    padding-left: 0;
  }

  .choose {
    margin-top: 20px;
  }

  .echarts {
    width: 100%;
    height: 40px;
    background: #fafafa;
    opacity: 1;
    padding-left: 20px;
    line-height: 40px;
  }
  .clos {
    width: 100%;
    height: 310px;
    @media screen and (max-width: 1400px) {
      margin-top: 10px;
      height: 280px;
    }
    @media screen and (max-width: 1340px) {
      margin-top: 10px;
      height: 250px;
    }

    background: #ffffff;
    border: 1px solid #f3f4f7;
    opacity: 1;
    padding-left: 20px;
    .chartheight {
      height: 300px;
      @media screen and (max-width: 1400px) {
        margin-top: 10px;
        height: 250px;
      }
      @media screen and (max-width: 1340px) {
        margin-top: 10px;
        height: 230px;
      }
    }
  }
  .background {
    height: 32px;
    background: rgba(250, 250, 250, 1);
    opacity: 1;
    line-height: 32px;
    padding-left: 12px;
    margin-top: 26px;
    .title {
      display: inline-block;
      width: 2px;
      height: 14px;
      background: rgba(254, 77, 69, 1);
      opacity: 1;
      border-radius: 3px;
      vertical-align: middle;
    }
    .tips {
      width: 56px;
      height: 20px;
      font-size: 14px;
      font-weight: 500;
      line-height: 20px;
      color: rgba(51, 51, 51, 1);
      opacity: 1;
      vertical-align: middle;
    }
  }
}
</style>
